<template>
    <div>
        <notification-modal :vuexStore="vuexStore" :firstAction="firstAction" :firstActionText="firstActionText" :secondAction="secondAction" :secondActionText="secondActionText" :messageTitle="messageTitle" :message="message" :notificationType="notificationType" :resetVariable="resetVariable"></notification-modal>
    </div>
</template>

<script>
export default {
    data () {
        return {
            vuexStore: 'profile',
            messageTitle: 'Profile',
            message: 'You have unsaved changes. Are you sure you want to leave?',
            notificationType: 'warning',
            firstAction: 'closeModal',
            firstActionText: 'Yes, leave now',
            secondAction: 'close',
            secondActionText: 'No, go back',
            resetVariable: 'showProfileNotSaved'
        }
    },
}
</script>